class AccountSettings.WorkCalendarHoliday extends Backbone.Model
  defaults:
    id: null,
    from_date: '',
    from_time: '00:00',
    to_date: '',
    to_time: '23:59',
    name: '',
    active: true,
    timezone: 'GMT+0000'


class AccountSettings.WorkCalendarHolidayCollection extends Backbone.Collection
  model: AccountSettings.WorkCalendarHoliday
  url: '/keepcon/settings/work_calendar_holidays'

  save: =>
    $.ajax
      url: @url
      method: 'POST'
      data: JSON.stringify @
      contentType: 'application/json'
      success: (response) =>
        if response.success then @trigger('saveSuccess') else @trigger('saveError', response.errors)
      error: =>
        @trigger 'saveError'
